import axios from 'axios';
import jwt from 'jsonwebtoken';
import $store from '../store';
// eslint-disable-next-line import/no-cycle
import { logout } from './auth';

const HTTPClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

const getHasExpired = (token) => {
  if (token) {
    const { exp } = jwt.decode(token);
    const now = Date.now() / 1000;
    const hasExpired = exp - now <= 0;
    return { success: true, hasExpired };
  }
  return {
    success: false,
  };
};

const autoRefresh = async () => {
  const access_token = $store.getters['auth/getToken'];
  const { success, hasExpired } = getHasExpired(access_token);

  if (success && hasExpired) {
    const refresh_token = $store.getters['auth/getRefreshToken'];
    const { success: successRefreshToken, hasExpired: hasExpiredRefreshToken } =
      getHasExpired(refresh_token);

    if (successRefreshToken && !hasExpiredRefreshToken) {
      const newAccessToken = await axios.get(
        `${process.env.VUE_APP_API_URL}/refresh`,
        {
          headers: { Authorization: `Bearer ${refresh_token}` },
        }
      );
      return newAccessToken;
    }
  }
};

HTTPClient.interceptors.request.use(
  async (config) => {
    try {
      const newAccessToken = await autoRefresh();

      const verifyGotNewAccessToken =
        newAccessToken &&
        newAccessToken.data &&
        newAccessToken.data.access_token;

      const token = verifyGotNewAccessToken
        ? newAccessToken.data.access_token
        : $store.getters['auth/getToken'];

      if (verifyGotNewAccessToken) {
        $store.dispatch('auth/setToken', newAccessToken.data.access_token);
      }

      if (token) {
        config.headers.common.Authorization = `Bearer ${token}`;
      }

      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (response) => Promise.reject(response)
);

HTTPClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      await logout();
    }
    return Promise.reject(error);
  }
);

export default HTTPClient;
